import React from 'react';
import styles from '../index.module.scss';

const StreamPreviewItemSkeleton = () => (
  <div className={styles.StreamPreviewItemSkeleton}>
    <div className={styles.StreamPreviewItemSkeletonPoster} />
    <div className={styles.StreamPreviewItemSkeletonTextWrapper}>
      <div className={styles.StreamPreviewItemSkeletonTextWrapperTitleSkeleton} />
      <div className={styles.StreamPreviewItemSkeletonTextWrapperDescriptionSkeleton} />
    </div>
  </div>
);

export default StreamPreviewItemSkeleton;
